
// Range slider input (used for Donations)
(function($) { "use strict";

	var rangeSlider = function(){
	  var slider = $('.range-slider'),
	      range = $('.range-slider__range'),
	      value = $('.range-slider__value');
	    
	  slider.each(function(){

	    // value.each(function(){
	    //   var value = $(this).prev().attr('value');
	    //   $(this).html(value);
	    //   console.log(value);
	    // });

	    range.on('input', function(){
		     $(this).next(value).html(this.value);
			 // $('.range-slider__range').attr("step",5);
			 // $('.range-slider__range').attr("min",5);
	      // if(this.value <= 150){
	      //   $('.range-slider__range').attr("step",5);
	      //   $('.range-slider__range').attr("min",5);
	      // }else if(this.value >= 200){
	      //   $('.range-slider__range').attr("min",5);
	      //   $('.range-slider__range').attr("step",5);
	      // }
	    });
	  });
	};

	rangeSlider();

})(jQuery);
